const WORDS = [
  "Conciencia",
  "Comprensión",
  "Sistema Nervioso",
  "Regulación",
  "Transformación",
  "Integración",
];

export const Marquee = () => {
  const items = [...WORDS, ...WORDS];
  return (
    <div className="relative overflow-hidden border-y border-gold/20 bg-navy py-8" data-testid="marquee">
      <div className="flex w-max animate-marquee">
        {items.map((w, i) => (
          <div key={`${w}-${i}`} className="flex items-center">
            <span className="whitespace-nowrap px-10 font-serif text-3xl font-light italic text-gold/80 sm:text-4xl">
              {w}
            </span>
            <span className="text-gold/40">✦</span>
          </div>
        ))}
      </div>
    </div>
  );
};
